import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { setAlert } from '../../actions/alert';
import { register } from '../../actions/auth';
import PropTypes from 'prop-types';

const Register = ({ setAlert, register, isAuthenticated }) => {
  // const [formData, setFormData] = useState({
  //   name: '',
  //   email: '',
  //   password: '',
  //   password2: ''
  // });

  // const { name, email, password, password2 } = formData;

  // const onChange = (e) =>
  //   setFormData({ ...formData, [e.target.name]: e.target.value });

  // const onSubmit = async (e) => {
  //   e.preventDefault();
  //   if (password !== password2) {
  //     setAlert('Passwords do not match', 'danger');
  //   } else {
  //     register({ name, email, password });
  //   }
  // };

  if (isAuthenticated) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <Fragment>

      <div className="auth-section">
        {/* <h1 className="">Register</h1> */}
        <h4 className="form-header">Sign up is currently disabled</h4>
        {/* <form className="account-form" onSubmit={(e) => onSubmit(e)}>
          <div className="form-row"></div>

          <div className="form-row">
            <div className="form-group col-12">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={name}
                onChange={(e) => onChange(e)}
                placeholder="Jane Doe"
                required
              />
            </div>

            <div className="form-group col-12">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={email}
                onChange={(e) => onChange(e)}
                placeholder="JaneDoe@gmail.com"
                required
              />
            </div>
            <div className="form-group col-12">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder=""
                name="password"
                value={password}
                onChange={(e) => onChange(e)}
                required
              />
            </div>
            <div className="form-group col-12">
              <label htmlFor="password2">Confirm Password</label>
              <input
                type="password"
                className="form-control"
                id="password2"
                placeholder=""
                name="password2"
                value={password2}
                onChange={(e) => onChange(e)}
                required
              />
            </div>
          </div>

          <div className="my-2">
            By signing up you agree to the{' '}
            <Link to="/tos" target="_blank">
              Terms of Service
            </Link>
            , including{' '}
            <Link to="/tos#cookie" target="_blank">
              Cookie Use
            </Link>
            .
          </div>
          <input
            type="submit"
            className="btn primary-btn auth-btn"
            value="Sign Up"
          />
        </form> */}
        <p className="change-form-text">
          Already have an account? <Link to="/login">Sign In</Link>
        </p>
      </div>
    </Fragment>
  );
};

Register.propTypes = {
  setAlert: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { setAlert, register })(Register);
